import { render, staticRenderFns } from "./shipping-details.vue?vue&type=template&id=13f91f1f&"
import script from "./shipping-details.vue?vue&type=script&lang=js&"
export * from "./shipping-details.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports